import { i as isMap$1 } from '../is-map/index.js';
import { i as isSet$1 } from '../is-set/index.js';
import { i as isWeakmap } from '../is-weakmap/index.js';
import { i as isWeakset } from '../is-weakset/index.js';

var isMap = isMap$1;
var isSet = isSet$1;
var isWeakMap = isWeakmap;
var isWeakSet = isWeakset;

var whichCollection = function whichCollection(value) {
	if (value && typeof value === 'object') {
		if (isMap(value)) {
			return 'Map';
		}
		if (isSet(value)) {
			return 'Set';
		}
		if (isWeakMap(value)) {
			return 'WeakMap';
		}
		if (isWeakSet(value)) {
			return 'WeakSet';
		}
	}
	return false;
};

export { whichCollection as w };
